// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ImagePreview-ImageDetails-module__overlay--rhbCG {
  background-color: rgba(0, 0, 0, 0.75);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}
.src-components-ImagePreview-ImageDetails-module__sliderTop--WfBez {
  display: block;
  width: 100vw;
  height: 100vh;
  padding: 24px 24px 32px;
}
.src-components-ImagePreview-ImageDetails-module__sliderBorder--kxmii {
  position: relative;
  height: calc(100%);
  width: calc(100%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-components-ImagePreview-ImageDetails-module__info--X5EyT {
  color: white;
  font-weight: bold;
  font-family: arial, sans-serif;
  font-size: 16px;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: -22px;
  text-align: center;
}
.src-components-ImagePreview-ImageDetails-module__nameBox--rqjBN {
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: center;
}
.src-components-ImagePreview-ImageDetails-module__name--UaYP2 {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 16px;
  text-align: center;
  padding: 8px 16px;
}
.src-components-ImagePreview-ImageDetails-module__obutton--rqx53 {
  background-color: rgba(255, 255, 255, 0.7);
  color: black;
  border: none;
  position: absolute;
  z-index: 1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.src-components-ImagePreview-ImageDetails-module__closeButton--rxJQc {
  width: 40px;
  height: 40px;
  right: 0;
  top: 0;
  border-radius: 50%;
}
.src-components-ImagePreview-ImageDetails-module__obutton--rqx53:hover {
  background-color: rgba(255, 255, 255, 0.9);
}
.src-components-ImagePreview-ImageDetails-module__vbutton--T74vK {
  width: 20px;
  height: 60px;
  top: calc(50% - 30px);
  border-radius: 4px;
}
.src-components-ImagePreview-ImageDetails-module__leftButton--m9a1i {
  width: 20px;
  height: 60px;
  top: calc(50% - 30px);
  border-radius: 4px;
  left: 0;
}
.src-components-ImagePreview-ImageDetails-module__rightButton--Df5aa {
  width: 20px;
  height: 60px;
  top: calc(50% - 30px);
  border-radius: 4px;
  right: 0;
}
.src-components-ImagePreview-ImageDetails-module__frame--Sfqlv {
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.2s ease;
  transition: opacity 0.2s ease;
}
.src-components-ImagePreview-ImageDetails-module__spin--JJN7w {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=ImageDetails.module.css.map */`, "",{"version":3,"sources":["webpack://./ImageDetails.module.less","webpack://./src/components/ImagePreview/ImageDetails.module.less"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;ACCF;ADEA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;ACAF;ADGA;EACE,kBAAA;EAEA,kBAAA;EACA,iBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;ACHF;ADMA;EACE,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;ACJF;ADOA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;ACLF;ADOA;EACE,oCAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ACLF;ADQA;EACE,0CAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ACNF;ADSA;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,kBAAA;ACPF;ADUA;EACE,0CAAA;ACRF;ADWA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;ACTF;ADYA;EANE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAKA,OAAA;ACPF;ADUA;EAXE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAUA,QAAA;ACLF;ADQA;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,6BAAA;ACNF;ADSA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACPF;AACA,kDAAkD","sourcesContent":[".overlay {\n  background-color: rgba(0, 0, 0, 0.75);\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 999;\n}\n\n.sliderTop {\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  padding: 24px 24px 32px;\n}\n\n.sliderBorder {\n  position: relative;\n  // border: thin dotted white;\n  height: calc(100%);\n  width: calc(100%);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.info {\n  color: white;\n  font-weight: bold;\n  font-family: arial, sans-serif;\n  font-size: 16px;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  bottom: -22px;\n  text-align: center;\n}\n\n.nameBox {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 0;\n  display: flex;\n  justify-content: center;\n}\n.name {\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 16px;\n  text-align: center;\n  padding: 8px 16px;\n}\n\n.obutton {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: black;\n  border: none;\n  position: absolute;\n  z-index: 1;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n}\n\n.closeButton {\n  width: 40px;\n  height: 40px;\n  right: 0;\n  top: 0;\n  border-radius: 50%;\n}\n\n.obutton:hover {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.vbutton {\n  width: 20px;\n  height: 60px;\n  top: calc(50% - 30px);\n  border-radius: 4px;\n}\n\n.leftButton {\n  .vbutton();\n  left: 0;\n}\n\n.rightButton {\n  .vbutton();\n  right: 0;\n}\n\n.frame {\n  max-width: 100%;\n  max-height: 100%;\n  transition: transform 0.2s ease;\n  transition: opacity 0.2s ease;\n}\n\n.spin {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n",".overlay {\n  background-color: rgba(0, 0, 0, 0.75);\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 999;\n}\n.sliderTop {\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  padding: 24px 24px 32px;\n}\n.sliderBorder {\n  position: relative;\n  height: calc(100%);\n  width: calc(100%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.info {\n  color: white;\n  font-weight: bold;\n  font-family: arial, sans-serif;\n  font-size: 16px;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  bottom: -22px;\n  text-align: center;\n}\n.nameBox {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 0;\n  display: flex;\n  justify-content: center;\n}\n.name {\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 16px;\n  text-align: center;\n  padding: 8px 16px;\n}\n.obutton {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: black;\n  border: none;\n  position: absolute;\n  z-index: 1;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n}\n.closeButton {\n  width: 40px;\n  height: 40px;\n  right: 0;\n  top: 0;\n  border-radius: 50%;\n}\n.obutton:hover {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n.vbutton {\n  width: 20px;\n  height: 60px;\n  top: calc(50% - 30px);\n  border-radius: 4px;\n}\n.leftButton {\n  width: 20px;\n  height: 60px;\n  top: calc(50% - 30px);\n  border-radius: 4px;\n  left: 0;\n}\n.rightButton {\n  width: 20px;\n  height: 60px;\n  top: calc(50% - 30px);\n  border-radius: 4px;\n  right: 0;\n}\n.frame {\n  max-width: 100%;\n  max-height: 100%;\n  transition: transform 0.2s ease;\n  transition: opacity 0.2s ease;\n}\n.spin {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/*# sourceMappingURL=ImageDetails.module.css.map */"],"sourceRoot":""}]);
// Exports
export var overlay = `src-components-ImagePreview-ImageDetails-module__overlay--rhbCG`;
export var sliderTop = `src-components-ImagePreview-ImageDetails-module__sliderTop--WfBez`;
export var sliderBorder = `src-components-ImagePreview-ImageDetails-module__sliderBorder--kxmii`;
export var info = `src-components-ImagePreview-ImageDetails-module__info--X5EyT`;
export var nameBox = `src-components-ImagePreview-ImageDetails-module__nameBox--rqjBN`;
export var name = `src-components-ImagePreview-ImageDetails-module__name--UaYP2`;
export var obutton = `src-components-ImagePreview-ImageDetails-module__obutton--rqx53`;
export var closeButton = `src-components-ImagePreview-ImageDetails-module__closeButton--rxJQc`;
export var vbutton = `src-components-ImagePreview-ImageDetails-module__vbutton--T74vK`;
export var leftButton = `src-components-ImagePreview-ImageDetails-module__leftButton--m9a1i`;
export var rightButton = `src-components-ImagePreview-ImageDetails-module__rightButton--Df5aa`;
export var frame = `src-components-ImagePreview-ImageDetails-module__frame--Sfqlv`;
export var spin = `src-components-ImagePreview-ImageDetails-module__spin--JJN7w`;
export default ___CSS_LOADER_EXPORT___;
